import React, { memo, useMemo } from 'react';
import { makeStyles } from '@material-ui/core';
import { ITooltip } from '../../../components/1elements';
import { useHMapContext } from '../hooks/useHMapContext';
import { ReactComponent as FilterButton } from '../../../components/1elements/Icons/svg/heatMap/dataZoneButton.svg';

const HMapDataZoneButton = ({ className }) => {
  const { snackbar, geoZoneStateInfo, allGeoZoneList, heatmapGeoZoneList } =
    useHMapContext();
  const [isSnackbarOpen, setIsSnackbarOpen] = snackbar;
  const [geoZoneState, toggleGeoZoneState] = geoZoneStateInfo;
  const [allGeoZones] = allGeoZoneList;
  const [heatmapGeoZone, setHeatmapGeoZone] = heatmapGeoZoneList;
  const geoZoneExist = useMemo(
    () => allGeoZones !== 'loading' && allGeoZones && allGeoZones.length,
    [allGeoZones]
  );
  const classes = useStyles({ active: geoZoneState });

  const handleGeoZoneButtonClick = () => {
    if (geoZoneState && heatmapGeoZone && heatmapGeoZone.length) {
      setHeatmapGeoZone([]);
    }

    if (geoZoneExist) {
      return toggleGeoZoneState();
    }

    setIsSnackbarOpen({
      ...isSnackbarOpen,
      message: 'There are no Geo-Zones',
      severity: 'fail',
      isOpen: true
    });
  };

  return (
    <div className={className} onClick={handleGeoZoneButtonClick}>
      <ITooltip placement={'left'} content={'Data Zones'}>
        <div className={`${classes.root} ${className}`}>
          <FilterButton />
        </div>
      </ITooltip>
    </div>
  );
};

export default memo(HMapDataZoneButton);

const useStyles = makeStyles((theme) => ({
  root: {
    width: '40px',
    height: '40px',
    padding: '8px',
    backgroundColor: (props) => (props.active ? '#ededed' : 'white'),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '12px',
    border: (props) =>
      props.active
        ? '1px solid #ededed'
        : `1px solid ${theme.palette.quaternary.main}`,
    transition: 'border 0.3s ease-in-out',
    boxShadow: '0px 0px 6px #00000029',
    '&:hover': {
      border: `1px solid ${theme.palette.secondary.accent}`,
      cursor: 'pointer'
    }
  }
}));
